import OnboardTableComponent from "./OnboardTableComponent";
import WeeklyOnboardTable from "./WeeklyOnboardTable";
import LoadingButtonComponent from "../LoadingButtonComponent";
import { useEffect, useRef } from "react";
import { useState } from "react";
import {  makeDownloadPdf } from "../utils";
import ModalLoadingScreen from "../ModalLoadingScreen";
import DuplicateRecordTable from "../DuplicateRecordTable";
import { useSearchParams } from "react-router-dom";

export default (({ onClose, referralData = [], loading = false, formData, historyData = {} }) => {
    const mainRef = useRef(null);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [showDuplicate, setShowDuplicate] = useState(false);
    const [searchParams] = useSearchParams();
    const duplicate = searchParams.get("duplicate");

    const handleDownloadPdf = async () => {
        setDownloadLoading(true);
        try {
           await makeDownloadPdf({referralData,formData},'#f7fafe','referral-report');    
        } catch (err) {
            console.error(err);
        } finally {
            setDownloadLoading(false);
        }
    };

     useEffect(()=>{
        // if(referralData.length){        
        //     localStorage.setItem('referralData',JSON.stringify(referralData));
        //     localStorage.setItem('formData',JSON.stringify(formData));
        // }
        if(referralData.areaTableData && referralData.areaTableData.length){        
            localStorage.setItem('referralData',JSON.stringify(referralData.areaTableData));
            localStorage.setItem('formData',JSON.stringify(formData));
        }
    },[referralData])

    // if (loading || referralData.length < 1) {
    if (loading || !referralData.areaTableData || referralData.areaTableData.length < 1) {
        return <ModalLoadingScreen loading={loading} title="Referral Report" onClose={() => onClose(false)} />
    }
   

    return <>
        <div className="modal-header">
            <div className="d-flex justify-content-between w-full align-items-center">
                <h5 className="modal-title">
                    Referral Report
                </h5>
                <div className="pe-6 ">
                    <LoadingButtonComponent
                        disabled={downloadLoading}
                        onClick={handleDownloadPdf}
                        type="button" className="btn btn-sm btn-info text-white "
                        title="Download PDF"
                        loadingTitle="Generating PDF..."
                        loading={downloadLoading}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-download h-4 w-4 mt-1"
                            data-lov-id="src\components\ReportsTab.tsx:384:18">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="7 10 12 15 17 10"></polyline>
                            <line x1="12" x2="12" y1="15" y2="3"></line>
                        </svg>
                    </LoadingButtonComponent>
                    {
                        duplicate &&
                        <button className="btn btn-sm btn-light ms-2" type="button" onClick={() => setShowDuplicate(!showDuplicate)}>
                            {showDuplicate ? 'Hide ' : 'Show '} Duplicate
                        </button>
                    }
                </div>

            </div>
            <button type="button" className="btn-close" onClick={() => onClose(false)}></button>
        </div>
        <div
            // style={{ background: '#f7fafe' }}
            className="modal-body" >
            <div ref={mainRef} className="p-6" >
                {/* style={{
                backgroundImage: `url('/report/bg.png')`,
                backgroundPosition: 'center',
                backgroundRepeat: 'repeat'
            }} */}
                {
                    showDuplicate &&
                    // <DuplicateRecordTable referralData={referralData} />
                    <DuplicateRecordTable referralData={referralData.areaTableData} />
                }

                <div>
                    <div className="pdf-element" data-type="table">
                        <div>
                            <div className="d-flex justify-content-center">
                                <div className="text-center bg-white px-4 py-2 rounded">
                                    <h3 className="header1">Onboarderd Report</h3>
                                    <p className="heading2">
                                        {formData._fromDate} - {formData._toDate}
                                    </p>
                                </div>
                            </div>

                            {/* <OnboardTableComponent referralData={referralData} /> */}
                            <OnboardTableComponent referralData={referralData.divisonTableData} areaTableData={referralData.areaTableData} />
                        </div>
                    </div>


                    {/* <WeeklyOnboardTable referralData={referralData} /> */}
                    <WeeklyOnboardTable referralData={referralData.areaTableData} />
                </div>
            </div>
        </div>
    </>
})
